import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import $ from 'npm-zepto';

import { createContainer } from '@dbk-legacy/muster/react';

import { Small } from '@dbk/ui-text';
import Button from '@dbk/ui-buttons';
import { TextInput } from '@dbk/ui-forms';
import { CHANNEL_TYPES } from '../../../constants';

import { LoadingCircle } from '../loading';

class RSA extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      errorTxt: '',
      inputToken: ''
    };

    this.handleValidateToken = this.handleValidateToken.bind(this);

  }

  handleValidateToken() {
    this.setState({ isLoading: true });
    let rsaToken = this.state.inputToken;
    var isnum = /^\d+$/.test(rsaToken);
    const {
      settings: {
        currentEnvironment: { remoteUrl },
      },
      auth: { userId, authHeader }, i18n: { messages }
    } = this.props;


    if (isnum || rsaToken == "") {
      if ((rsaToken.length == 7 || rsaToken.length < 6 || rsaToken.length > 14)) {
        this.setState({ isLoading: false, errorTxt: messages['app.rsa.tokenErr.digitError'] });
      }
      else if (remoteUrl != null) {
        console.log("authHeader inside remoteUrl:", authHeader);
        const RSA_URL = remoteUrl + '/pbauthentication/' + this.props.app.config.apiverion + '/rsa-authentication';
        //APAC UAT3 for local testing
        // const RSA_URL = "https://uat3.deutschewealthonline.db.com/ebanking/pbauthentication/1.0/rsa-authentication";
        // APAC UAT1 for local testing
        // const RSA_URL = "https://uat1.deutschewealthonline.intranet.db.com/ebanking/pbauthentication/1.0/rsa-authentication";
        // APAC DEV for local testing
        // const RSA_URL = "https://dev.deutschewealthonline.intranet.db.com/ebanking/pbauthentication/1.0/rsa-authentication";
        // APAC DEV 2 for local testing
        // const RSA_URL = "https://int9.mywealthasia.intranet.db.com/ebanking/pbauthentication/1.0/rsa-authentication";

        const inputs = {
          'userId': userId,
          'tokenId': rsaToken,
          'channel': CHANNEL_TYPES.WEB
        };

        $.ajax({
          type: 'POST',
          url: RSA_URL,
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Authorization-Token': authHeader
          },
          dataType: 'json',
          contentType: 'application/json',
          data: JSON.stringify(inputs),
          success: function (responseJson) {
            if (responseJson.retCode == 0) {
              this.props.rsa.onHideRsa();
              this.routePage(responseJson.retCode, responseJson.jwt);
              this.setState({ isLoading: false, errorTxt: '' });
            } else if (responseJson.retCode == 5) {
              this.routePage(responseJson.retCode, '');
            } else {
              this.routePage(1, '');
            }
          }.bind(this),
          error: function (request, status, error) {
            console.log("error", error);
            this.setState({ errorTxt: messages['app.auth.logoutExpireSuccess.text'], isLoading: false });
            this.props.auth.logout();
          }.bind(this)
        });
      }
      else {
        if (rsaToken === "00000000") {
          this.routePage(5, '');
        } else {
          this.routePage(0, '');
        }
      }
    } else {
      this.setState({ isLoading: false, errorTxt: messages['app.token.numeric.characters'] });
    }

  }

  routePage(rsaTokenStatus, jwt) {
    const { i18n: { messages } } = this.props;
    if (rsaTokenStatus == 0) {
      this.props.rsa.onValidateToken({
        rsaTokenStatus,
        jwt
      });
    }
    else if (rsaTokenStatus == 5) {
      this.setState({ isLoading: false });
      this.props.rsa.onShowRsaPin();
      return;
    }
    else {
      this.setState({ isLoading: false, errorTxt: messages['app.rsa.invalidToken.tryAgn'] });
      return;
    }
  }


  handleTokenChange(event) {
    let value = event.target.value.toString();
    this.setState({ inputToken: value });
  }

  handleSubmitToken(event) {
    const { nativeEvent: { key } } = event;
    if (key == "Enter") {
      this.handleValidateToken();
    }
  }

  render() {
    const {
      rsaToken,
      isLoading,
    } = this.state;
    const {
      i18n: { messages },
    } = this.props;

    return (
      <div className="scene">
        <div className="row change-password">
          <div className="columns small-12 text-center paddingClass">
            <div className="module">
              {!isLoading &&
                <div>
                  <div className="pad-bottom-10">
                    <Small secondary>{messages['app.token.header.label.text']}</Small>
                  </div>
                  {this.state.errorTxt != '' ? <Small style={{ color: 'red' }}>{this.state.errorTxt}</Small>
                    : ''}
                  <div className="row">
                    <div className="column small-12 medium-12 large-push-1 large-10">
                      <div className="flexClass">

                        <TextInput maxLength={14}
                          className="rsaBox"
                          autoComplete="new-password"
                          type="password"
                          onChange={(event) => this.handleTokenChange(event)}
                          value={this.state.inputToken}
                          onKeyPress={(event) => this.handleSubmitToken(event)} />

                      </div>
                      <div className="small-12 medium-push-2 medium-8 large-8 pad-top-20">
                        <Button onClick={this.handleValidateToken}>
                          {messages['app.rsa.validateTkn']}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              }
              {isLoading &&
                <LoadingCircle />
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

RSA.propTypes = {
  rsa: PropTypes.shape({
    deviceToken: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.shape({
        service: PropTypes.string,
        username: PropTypes.string,
        password: PropTypes.string,
      }),
    ]),
    onValidateToken: PropTypes.func,
    onValidateDevice: PropTypes.func,
    onChangePage: PropTypes.func,
    onHideRsa: PropTypes.func,
  }),
  i18n: PropTypes.shape({
    messages: PropTypes.object.isRequired,
  }),
};

export default createContainer({
  $queries: {
    app: {
      config: {
        apiverion: true
      }
    },
    rsa: {
      onValidateToken: { $call: 'validateToken' },
      rsaAuthorised: true,
      rsaVisible: true,
      onChangePage: { $call: 'changePage' },
      onHideRsa: { $call: 'hideRsa' },
      onShowRsaPin: { $call: 'showRsaPin' },
    },
    screen: {
      width: true,
      height: true,
      isSmall: true
    },
    i18n: {
      messages: true,
    },
    auth: {
      userId: true,
      authHeader: true,
      logout: { $call: 'logout' }
    },
    settings: {
      currentEnvironment: {
        remoteUrl: true,
      },
    },
  }
})(RSA);
